<template>
  <transition name="fade">
    <div
      v-if="visible"
      class="fixed top-0 left-0 text-white z-50 transition-all overflow-hidden"
      :class="{
        'w-full mx-auto px-4 py-3 flex items-center justify-between':
          !minimized,
        'w-8 h-8 top-2 left-2 rounded-lg p-1 fixed ': minimized,
        'bg-green-500': isOnline,
        'bg-red-500': !isOnline,
      }"
    >
      <span class="font-bold text-sm sm:text-base" v-if="!minimized">
        {{ message }}
      </span>

      <button
        v-if="!minimized"
        @click="handleClose"
        aria-label="Fermer"
        class="ml-4 p-1 rounded hover:opacity-80 focus:outline-none focus:ring focus:ring-yellow-400/40"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-4 w-4 sm:h-5 sm:w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10 8.586l4.95-4.95a1 1 0 111.414 1.414L11.414 10l4.95 4.95a1 1 0 11-1.414 1.414L10 11.414l-4.95 4.95a1 1 0 11-1.414-1.414L8.586 10l-4.95-4.95A1 1 0 115.05 3.636L10 8.586z"
            clip-rule="evenodd"
          />
        </svg>
      </button>
      <button
        aria-label="Fermer"
        v-if="minimized"
        @click="minimized = false"
        class="p-1 rounded hover:opacity-80 focus:outline-none focus:ring focus:ring-yellow-400/40"
      >
        <ColorImg src="/images/required/no-network.png" class="bg-current w-5 h-5" :fallback="noNetworkImg" />
      </button>
    </div>
  </transition>
</template>

<script setup>
import Storage from '@/shared/utils/storage'
import { ref, onUnmounted, watch, computed, onMounted } from 'vue'
import ColorImg from '../../img/ColorImg.vue'
import noNetworkImg from "./no-network.png"

const initiationDelayPassed = ref(false)
const visible = ref(false)
const minimized = ref(false)
const message = ref(
  'Connexion Internet perdue. Certaines fonctions peuvent être limitées.',
)
const onlineStatus = Storage.useValue('onlineStatus')
const isOnline = computed(() => {
  return !onlineStatus?.value?.isOffline
})
let autoHideTimer = null

/** Cache la bannière après un délai */
function scheduleHide() {
  clearTimeout(autoHideTimer)
  autoHideTimer = setTimeout(() => {
    visible.value = false
  }, 3000)
}

function handleClose() {
  if (!isOnline.value) {
    // Réduit la bannière si toujours hors ligne
    minimized.value = true
  } else {
    // Ferme complètement
    visible.value = false
  }
}

watch(
  isOnline,
  newValue => {
    if (newValue == false) {
      minimized.value = false
      message.value =
        'Connexion Internet perdue. Certaines fonctions peuvent être limitées.'
      visible.value = true
    } else {
      if (initiationDelayPassed.value !== true) {
        visible.value = false
      } else {
        minimized.value = false
        message.value = 'Connexion rétablie'
        visible.value = true
        scheduleHide()
      }
    }
  },
  { immediate: true },
)

onMounted(() => {
  setTimeout(() => {
    initiationDelayPassed.value = true
  }, 5000)
})

onUnmounted(() => {
  clearTimeout(autoHideTimer)
})
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
